const defaultRules = {
  minLength: 5,
  maxLength: 20,
  required: false,
};

const required = {required: true};

const rules = {
  BE: required,
  BG: required,
  CH: {
    required: true,
    minLength: 11,
    maxLength: 12,
    regexValidation: [/^(41)/, /^(\+41)/],
  },
  CN: required,
  CY: required,
  CZ: {
    required: true,
    maxLength: 13,
    regexValidation: [/^(420)\d{1,9}$/, /^(\+420)\d{1,9}$/],
  },
  DK: {
    required: true,
    minLength: 8,
    maxLength: 17,
    regexValidation: [
      /^(\+45)\d{1,9}$/,
      /^(0045)\d{1,9}$/,
      /^(2)\d{1,9}$/,
      /^(30)\d{1,9}$/,
      /^(31)\d{1,9}$/,
      /^(40)\d{1,9}$/,
      /^(41)\d{1,9}$/,
      /^(42)\d{1,9}$/,
      /^(50)\d{1,9}$/,
      /^(51)\d{1,9}$/,
      /^(52)\d{1,9}$/,
      /^(53)\d{1,9}$/,
      /^(60)\d{1,9}$/,
      /^(61)\d{1,9}$/,
      /^(71)\d{1,9}$/,
      /^(81)\d{1,9}$/,
      /^(91)\d{1,9}$/,
    ],
  },
  EE: required,
  ES: required,
  FI: {
    required: true,
    minLength: 8,
    maxLength: 16,
    regexValidation: [/^(\+3584)\d{1,9}$/, /^(\+3585)\d{1,9}$/, /^(04)\d{1,9}$/, /^(05)\d{1,9}$/],
  },
  FR: required,
  GR: {
    required: true,
  },
  HR: required,
  HU: {
    required: true,
    minLength: 6,
    maxLength: 13,
    regexValidation: [/^(36)/, /^(\+36)/, /^(0)/, /^(\+0)/],
  },
  IL: required,
  IN: {
    minLength: 10,
    maxLength: 15,
  },
  IT: required,
  JP: {
    minLength: 10,
    maxLength: 11,
    regexValidation: [/^(0)/],
  },
  KR: required,
  LT: {
    required: true,
    minLength: 8,
    maxLength: 13,
    regexValidation: [/^(37)/, /^(\+37)/, /^(0)/, /^(\+0)/],
  },
  LV: {
    required: true,
    minLength: 7,
    maxLength: 13,
    regexValidation: [/^(37)/, /^(\+37)/, /^(0)/, /^(\+0)/],
  },
  NO: {
    required: true,
    minLength: 8,
    maxLength: 8,
  },
  PL: {
    required: true,
    maxLength: 12,
    regexValidation: [/^(48)\d{1,9}$/, /^(\+48)\d{1,9}$/],
  },
  PT: required,
  RO: required,
  RU: required,
  SE: {
    required: true,
    minLength: 10,
    maxLength: 16,
    regexValidation: [/^(\+467)\d{1,9}$/, /^(00467)\d{1,9}$/, /^(07)\d{1,9}$/],
  },
  SK: {
    required: true,
    maxLength: 13,
    regexValidation: [/^(421)\d{1,9}$/, /^(\+421)\d{1,9}$/],
  },
  SI: {
    required: true,
    minLength: 7,
    maxLength: 13,
    regexValidation: [/^(38)/, /^(\+38)/, /^(0)/, /^(\+0)/],
  },
};

export default function getContactNumberRulesByCountry(country) {
  let rulesByCountry = rules[country];
  
  if (country === 'GB' && window.start.settings.should_use_uk_mobile_validation_only) {
    rulesByCountry = {
      minLength: 11,
      maxLength: 16, // to allow extra chars e.g +44 or spacing +447 447 057 110
      regexValidation: [/^((\+447|447)|(07|\+07))/], // uk mobile numbers only
    };
  }
  
  if (country === 'SA' && window.start.settings.should_use_sa_mobile_validation) {
    rulesByCountry = {
      required: true,
    };
  }
  
  return rulesByCountry ? {...defaultRules, ...rulesByCountry} : defaultRules;
}
